import { Accordion, Card, Grid, InputSelect, InputText, Select } from "#/atoms";
import { Datepicker, HeadingIcon, Timepicker } from "#/molecules";
import { forwardRef, memo, useImperativeHandle } from "react";

import { CardHandle } from "../Cards.interface";
import { DESKTOP_SPACING } from "@/theme";
import { KeysCardProps } from "./Keys.interface";

const KeysCard = forwardRef<CardHandle, KeysCardProps> (
  ({
  accordionState = 'open',
  isReadOnly,
  keyNotes,
  keys,
  keysTime,
  keysTimeOption,
  keysWith,
  keysWithDetail,
}, ref) => {
  
  useImperativeHandle(ref, () => ({
    validate: () => {
      return { isValid: Number(isReadOnly) > 0, validationErrors: [ 'Invalid number']};
    }
  }));

  return (
    <Card>
      <Accordion
        header={<HeadingIcon icon="key" title="Keys" />}
        headerMargin={`${DESKTOP_SPACING.XXXL}px`}
        showArrow
        state={accordionState}
      >
        <InputSelect
          type="checkbox"
          checked={keys.checked}
          label="Keys will be needed."
          name="need-keys"
          value="need-keys"
          onChangeValue={keys.onChange}
          readOnly={isReadOnly}
        />
        <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(2, 40%)" margin={`${DESKTOP_SPACING.XXL}px 0 0`}>
          <Select
            label="With"
            options={[{ id: 'Agent', label: 'Agent' }, { id: 'Porter', label: 'Porter' }]}
            selected={keysWith.value}
            onChange={keysWith.onChange}
            readOnly={isReadOnly}
          />
          <InputText
            type="text"
            label="Contact Details"
            value={keysWithDetail.value}
            onChange={keysWithDetail.onChange}
            readOnly={isReadOnly}
          />
          <Select
            label="Available"
            options={[{ id: 'Any time', label: 'Any time' }, { id: 'Specific time', label: 'Specific time' }]}
            selected={keysTimeOption.value}
            onChange={keysTimeOption.onChange}
            readOnly={isReadOnly}
          />
          <Timepicker label="At" time={keysTime.value} onChange={keysTime.onChange} />
          <InputText type="text" label="Notes" value={keyNotes.value} onChange={keyNotes.onChange} readOnly={isReadOnly} />
        </Grid>
      </Accordion>
    </Card>
  );
}
);

KeysCard.displayName = 'KeysCard';

export default memo(KeysCard);